export default "__VITE_ASSET__BryRFzgm__"